const getIconColorForUse = (use, disabled, theme) => {
  if (disabled) {
    return 'inherit';
  }
  switch (use) {
    case 'on-dark':
      return theme.color['icon-interactive-on-fill-default'];
    case 'on-bright':
      return theme.color['icon-core-default'];
    case 'blue':
    case 'dark':
    case 'light':
    case 'mention':
      return theme.color['icon-interactive-default'];
    case 'danger':
      return theme.color['icon-alert-default'];
    case 'unstyled':
      return undefined;
    // No color override for unstyled
    default:
      {
        const __exhaustiveCheck = use;
        throw new Error(`Unhandled \`use\` argument: ${use}`);
      }
  }
};
export const getLinkIconStyles = (use, disabled, theme) => {
  const color = getIconColorForUse(use, disabled, theme);
  return Object.assign({
    marginInlineEnd: theme.space['200'],
    verticalAlign: '-0.25em'
  }, color && {
    color
  });
};